var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/lodash/_nativeCreate.js
// module id = 965
// module chunks = 3 9 13